import { useState } from 'react'

import { customPost } from '../../../utils/customFetch.ts'
import { makeUrlProfileCrea, makeUrlProfileEdit } from '../../../hooks/connectionData.tsx'
import { UserProfileDto } from '../types/UserProfileDto.ts'

interface ApiParams {
  profileId: string

  roles: string[]
  userProfile: UserProfileDto
  modUser: boolean
}
const useUserProfilePoster = () => {
  const [errorPostUserProfile, setErrorPostUserProfile] = useState<Error | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)

  // Crea o modifica
  const postUserProfile = async (profileId: string, roles: string[], userProfile: UserProfileDto, modUser: boolean) => {
    setLoadingPost(true)

    try {
      const apiUrl = profileId.length === 0 ? makeUrlProfileCrea() : makeUrlProfileEdit()
      const apiParams: ApiParams = {
        profileId: profileId,
        userProfile: userProfile,
        roles: roles,
        modUser: modUser,
      }

      const res = await customPost<{ _id: string }>(apiUrl, apiParams)
      setErrorPostUserProfile(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostUserProfile(err)
      } else {
        setErrorPostUserProfile(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorPostUserProfile, loadingPost, postUserProfile }
}
export default useUserProfilePoster
